import { fullWidthCellClassName } from '../utils/fullWidthCellClassName';
import { HIGHLY_SENSITIVE_MASKED_DISPLAY } from './highlySensitiveMaskedDisplay';
import styled from 'styled-components';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { useProperty } from '../v2/hooks/useProperty';
import { useFetchHighlySensitivePropertyValue } from './useFetchHighlySensitivePropertyValue';
import { useState } from 'react';
import { trackShowHighlySensitiveValueClick } from '../utils/usageTrackingUtils';
import { useObjectTypeId } from '../v2/hooks/useObjectTypeId';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HighlySensitiveDataMaskedDisplayWrapper = styled.div.withConfig({
  displayName: "HighlySensitiveDataMaskedDisplay__HighlySensitiveDataMaskedDisplayWrapper",
  componentId: "ccswzk-0"
})(["position:relative;display:inline-flex;align-items:center;padding:", " 0;width:100%;"], ({
  theme
}) => theme.space[200]);
const LoadingButtonWrapper = styled.span.withConfig({
  displayName: "HighlySensitiveDataMaskedDisplay__LoadingButtonWrapper",
  componentId: "ccswzk-1"
})(["opacity:0;transition:opacity 0.15s ease;", ":hover &,&:has(button:focus){opacity:1;}"], HighlySensitiveDataMaskedDisplayWrapper);
const MaskedDisplay = styled.span.withConfig({
  displayName: "HighlySensitiveDataMaskedDisplay__MaskedDisplay",
  componentId: "ccswzk-2"
})(["margin-top:6px;opacity:1;position:absolute;transition:opacity 0.15s ease;", ":hover &,", ":has(", " button:focus) &{opacity:0;}"], HighlySensitiveDataMaskedDisplayWrapper, HighlySensitiveDataMaskedDisplayWrapper, LoadingButtonWrapper);
export const HighlySensitiveDataMaskedDisplay = ({
  dataAttributes
}) => {
  const {
    fetchHighlySensitivePropertyValue,
    highlySensitiveValueStatus
  } = useFetchHighlySensitivePropertyValue();
  const objectTypeId = useObjectTypeId();
  const property = useProperty();
  const [showValueFailed, setShowValueFailed] = useState(false);
  return /*#__PURE__*/_jsxs(HighlySensitiveDataMaskedDisplayWrapper, Object.assign({}, dataAttributes, {
    "data-classname": fullWidthCellClassName,
    children: [/*#__PURE__*/_jsx(MaskedDisplay, {
      children: HIGHLY_SENSITIVE_MASKED_DISPLAY
    }), /*#__PURE__*/_jsx(LoadingButtonWrapper, {
      children: /*#__PURE__*/_jsx(LoadingButton, {
        size: "extra-small",
        use: "link"
        // This prevents the success checkmark from showing when loading failed
        ,
        failed: showValueFailed,
        onClick: () => {
          trackShowHighlySensitiveValueClick({
            propertyName: property.name,
            objectTypeId
          });
          setShowValueFailed(false);
          fetchHighlySensitivePropertyValue().catch(() => {
            setShowValueFailed(true);
            FloatingAlertStore.addAlert({
              titleText: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "customerDataProperties.PropertyInputHighlySensitive.showValueErrorTitle"
              }),
              message: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "customerDataProperties.PropertyInputHighlySensitive.showValueErrorMessage"
              }),
              type: 'danger'
            });
          });
        },
        loading: highlySensitiveValueStatus === 'LOADING',
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataProperties.PropertyInputHighlySensitive.showValue"
        })
      })
    })]
  }));
};